<template>
  <v-card flat>
    <ValidationObserver ref="observer" v-slot="{ invalid, passes }">
      <v-card-subtitle
        class="greytext--text"
        v-html="$t('onboarding.verify.title')"
      ></v-card-subtitle>
      <v-card-text>
        <ValidationProvider vid="credentialsEmail" v-slot="{ errors }">
          <VTextFieldWithValidation
            clearable
            rules="required|email"
            v-model="email"
            :label="$t('onboarding.verify.email')"
            :error="errors.length > 0"
          />
        </ValidationProvider>

        <ValidationProvider vid="credentialsPassword" v-slot="{ errors }">
          <VTextFieldWithValidation
            clearable
            rules="required|min:8"
            v-model="password"
            counter
            :label="$t('onboarding.verify.password')"
            :append-icon="showpassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showpassword ? 'text' : 'password'"
            :hint="$t('onboarding.data.min8')"
            @click:append="showpassword = !showpassword"
            :error="errors.length > 0"
          />
          <span class="red--text">{{ errors[0] }}</span>
        </ValidationProvider>
      </v-card-text>

      <v-card-actions>
        <v-row class="mx-auto">
          <v-col cols="8">
            <v-text-field
              :hint="$t('spamProtection.description')"
              v-model="spamProtectionEntry"
              outlined
              class="rafiTextField"
              dense
              @input="spamProtectionAnswerChanged"
            >
              <template v-slot:prepend-inner>
                <span class="text-no-wrap mt-1"
                  >{{ $t("spamProtection.label") }}
                  {{ spamProtectionAnswer.summandLeft }} +
                  {{ spamProtectionAnswer.summandRight }} =</span
                >
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="4">
            <v-btn
              tile
              elevation="0"
              class="rafiButton petrol white--text mt-1"
              :loading="iswaitingForBackend"
              :disabled="invalid || !spamProtectionAnswerValid"
              @click="passes(submit)"
            >
              {{ $t("onboarding.form.verify") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </ValidationObserver>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import onboarding from "@/services/onboarding";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import VTextFieldWithValidation from "../../inputs/VTextFieldWithValidation";

export default {
  name: "verify-subtenant",
  components: {
    ValidationObserver,
    ValidationProvider,
    VTextFieldWithValidation,
  },
  mounted() {
    this.spamProtectionAnswer.summandLeft = this.getRandomInt();
    this.spamProtectionAnswer.summandRight = this.getRandomInt();

    this.$refs.observer.reset();
  },
  data() {
    return {
      iswaitingForBackend: false,
      spamProtectionEntry: null,
      spamProtectionAnswerValid: false,
      showpassword: false,
      spamProtectionAnswer: {
        summandLeft: 3,
        summandRight: 7,
        sum: 0,
      },
      rules: {
        required: (value) => !!value || this.$t("onboarding.data.required"),
        min8: (v) => v.length >= 8 || this.$t("onboarding.data.min8"),
        max32: (v) => v.length <= 32 || this.$t("onboarding.data.less32"),
      },
    };
  },
  computed: {
    ...mapGetters("onboarding", ["getVerifyEmail", "getVerifyPassword"]),
    email: {
      get() {
        return this.getVerifyEmail;
      },
      set(value) {
        this.setVerifyEmail(value);
      },
    },
    password: {
      get() {
        return this.getVerifyPassword;
      },
      set(value) {
        this.setVerifyPassword(value);
      },
    },
  },
  methods: {
    ...mapActions("onboarding", [
      "incrementLevel",
      "resetLevel",
      "setToken",
      "resetData",
      "setVerifyEmail",
      "setVerifyPassword",
    ]),
    getRandomInt() {
      return Math.floor(Math.random() * Math.floor(10));
    },
    submit: async function () {
      this.iswaitingForBackend = true;
      let result = await onboarding.getToken(
        this.email,
        this.password,
        this.spamProtectionAnswer
      );
      this.iswaitingForBackend = false;

      if (result && result.status == 200) {
        this.setToken(result.data);
        this.incrementLevel();
        this.spamProtectionAnswer.sum = 0;
        this.spamProtectionEntry = null;
        this.spamProtectionAnswer.summandLeft = this.getRandomInt();
        this.spamProtectionAnswer.summandRight = this.getRandomInt();

        requestAnimationFrame(() => {
          this.$refs.observer.reset();
        });

        return true;
      } else {
        this.spamProtectionAnswer.summandLeft = this.getRandomInt();
        this.spamProtectionAnswer.summandRight = this.getRandomInt();
        this.spamProtectionAnswer.sum = null;
        this.spamProtectionEntry = null;

        this.$refs.observer.setErrors({
          credentialsPassword: [result.message],
          credentialsEmail: [result.message],
        });
        return false;
      }
    },
    back() {
      this.spamProtectionAnswer.sum = 0;
      this.spamProtectionEntry = null;

      //back in slider
      this.resetLevel();
      //clear data
      this.resetData();
    },
    spamProtectionAnswerChanged() {
      this.$log.debug(this.spamProtectionEntry);

      this.spamProtectionAnswerValid =
        this.spamProtectionEntry ==
        this.spamProtectionAnswer.summandLeft +
          this.spamProtectionAnswer.summandRight;

      if (this.spamProtectionAnswerValid) {
        this.spamProtectionAnswer.sum = this.spamProtectionEntry;
      }
    },
  },
};
</script>

<style>
.greytext--text {
  font-size: 16px;
}
.rafiTextField {
  border-radius: 0px;
}
</style>